import styled from 'styled-components';
import { mq } from '../../theme/mediaQueries';

export const StyledForm = styled.form`
  width: 100%;
  max-width: 26rem;
  z-index: 10;
`;

export const StyledTableWrapper = styled.div`
  width: 100%;
  overflow: clip;

  > table {
    table-layout: fixed;
    min-width: 710px;
  }
`;

export const StyledCustomerCell = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
`;

export const StyledCustomerAvatar = styled.div<{ avatarBg?: string; avatarColor?: string }>`
  width: 32px;
  height: 32px;
  border-radius: 999px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: ${({ avatarColor }) => avatarColor ?? 'var(--ink-2)'};
  background-color: ${({ avatarBg }) => avatarBg ?? 'rgba(9,15,56,0.06)'};
  border: none;
`;

export const StyledCustomerInfo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const StyledCustomerName = styled.span`
  font-size: var(--t-md);
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.005em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.25;
`;

export const StyledCustomerSubtitle = styled.span`
  font-size: var(--t-xs);
  color: var(--muted);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.3;
  margin-top: 1px;
`;

export const StyledPhoneCell = styled.a`
  display: inline-block;
  direction: ltr;
  unicode-bidi: isolate;
  font-size: var(--t-sm);
  font-family: var(--font-mono);
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
  color: inherit;
  text-decoration: none;
  opacity: 0.7;
  &:hover { opacity: 1; }
`;

export const StyledCityPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: var(--s-1) var(--s-2);
  border-radius: 999px;
  background-color: rgba(9,15,56,0.05);
  color: var(--ink-2);
  font-size: 12.5px;
  font-weight: var(--weight-medium);
  white-space: nowrap;
  border: 1px solid var(--line);

  &::before {
    content: '';
    width: 5px;
    height: 5px;
    border-radius: 999px;
    background: var(--brand-green);
  }
`;

export const StyledOrderCount = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  font-variant-numeric: tabular-nums;

  strong {
    font-size: var(--t-base);
    font-weight: 700;
    color: var(--ink);
    letter-spacing: -0.005em;
  }
  span {
    font-size: var(--t-xs);
    color: var(--muted);
    font-weight: 400;
  }
`;

export const StyledValueCell = styled.div`
  display: inline-flex;
  align-items: baseline;
  gap: 5px;
  font-variant-numeric: tabular-nums;

  strong {
    font-size: var(--t-base);
    font-weight: 700;
    color: var(--ink);
    letter-spacing: -0.005em;
  }
  span {
    font-size: 11px;
    font-weight: var(--weight-medium);
    color: var(--muted);
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
`;

export const StyledActionCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s-1);
`;

export const StyledKpiStrip = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 280px));
  gap: var(--s-4);
  margin-bottom: var(--s-6);
`;

export const StyledCustomerGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: var(--s-4);
`;

export const StyledCustomerCardItem = styled.div`
  background: var(--surface);
  border-radius: var(--r-lg);
  box-shadow: var(--sh-1);
  padding: var(--s-4);
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: var(--s-3);
`;
